exports.encode = require('./encode');
exports.decode = require('./decode');



/*****************
 ** WEBPACK FOOTER
 ** ./~/ent/index.js
 ** module id = 538
 ** module chunks = 0
 **/